/**
 * @generated SignedSource<<f51078e2f34fe4c384685702357eaa5f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptPanel_SpeakerRelabelForm_attendees$data = ReadonlyArray<{
  readonly email: string | null;
  readonly fullName: string;
  readonly image: string | null;
  readonly isTopUser: boolean;
  readonly user: {
    readonly id: string;
  } | null;
  readonly " $fragmentType": "TranscriptPanel_SpeakerRelabelForm_attendees";
}>;
export type TranscriptPanel_SpeakerRelabelForm_attendees$key = ReadonlyArray<{
  readonly " $data"?: TranscriptPanel_SpeakerRelabelForm_attendees$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptPanel_SpeakerRelabelForm_attendees">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "TranscriptPanel_SpeakerRelabelForm_attendees",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "email",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "fullName",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "image",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isTopUser",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "User",
      "kind": "LinkedField",
      "name": "user",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "RecordingParticipant",
  "abstractKey": null
};

(node as any).hash = "1207bbc09ece9df53e030875b5a8a0b1";

export default node;
